// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionPerson-moduleApplicantDecisionPerson__e0Gbc";
var _2 = "ApplicantDecisionPerson-modulehead__Jwxe7";
var _3 = "ApplicantDecisionPerson-modulemuted__eFISD";
var _4 = "ApplicantDecisionPerson-moduletext__FUxwA";
export { _1 as "ApplicantDecisionPerson", _2 as "head", _3 as "muted", _4 as "text" }
